module.exports = __webpack_public_path__ + "static/media/home14.9be2c8de.jpg";